import React, { forwardRef, useState, useEffect } from 'react'
import { castArray } from 'lodash-es'
import { Select, SelectComponents as components } from '@ow/comps'
import { photoBgColor } from '@ow/utils'
import { useDitto } from '@ow/ditto-core'
import { multiSelectStyles, singleSelectStyles } from './style'
import closeImg from './assets/close.png'
import downImg from './assets/up.png'
import upImg from './assets/down.png'

const MultiValueRemove = (props) => {
  return (
    <components.MultiValueRemove {...props}>
      <img
        src={closeImg}
        alt=""
        style={{ width: '.875rem', height: '.875rem' }}
      />
    </components.MultiValueRemove>
  )
}

const MultiValueLabel = (props) => {
  const { data } = props
  return (
    <components.MultiValueLabel {...props}>
      <span style={{ fontSize: '.8125rem' }}>{data.title}</span>
    </components.MultiValueLabel>
  )
}

// 删除所有
const ClearIndicator = (props) => {
  return (
    <components.MultiValueLabel {...props}>
      <img
        className="ml-3"
        src={closeImg}
        alt=""
        style={{ width: '.875rem', height: '.875rem' }}
      />
    </components.MultiValueLabel>
  )
}

const DropdownIndicator = (props) => {
  const { isFocused } = props
  return (
    <components.DropdownIndicator {...props}>
      <img
        className="ml-3"
        src={isFocused ? downImg : upImg}
        alt=""
        style={{ width: '.6875rem', height: '.375rem' }}
      />
    </components.DropdownIndicator>
  )
}

const renderOptions = (data) => {
  return (
    <div
      className="flex flex-row items-center cursor-pointer"
      style={{
        borderRadius: '1rem',
        padding: '0.125rem',
        color: '#262626',
        background: 'rgba(38,38,38,.1)',
        fontSize: '0.8125rem',
      }}
    >
      {data.photo ? (
        <img className="rounded-full w-5 h-5" alt="" src={data.photo} />
      ) : (
        <div
          className="rounded-full flex items-center justify-center text-white w-5 h-5"
          style={{ background: photoBgColor(data.id) }}
        >
          {data.name ? data.name[0] : ''}
        </div>
      )}
      <span className="px-1.5 whitespace-nowrap">{data.name}</span>
    </div>
  )
}

const Option = (props) => {
  const { data } = props
  return <components.Option {...props}>{renderOptions(data)}</components.Option>
}

const Render = function ({ opts = {}, onChange, value, style }, ref) {
  const { multiple, readonly, valueField = 'id' } = opts
  const { onFetchRemoteData } = useDitto()
  const [users, setUsers] = useState([])

  const props = {}
  if (multiple) {
    props.components = {
      MultiValueLabel,
      MultiValueRemove,
      ClearIndicator,
      DropdownIndicator,
      Option,
    }
    props.isMulti = true
    props.isClearable = false
    props.styles = multiSelectStyles(style)
  } else {
    props.components = {
      MultiValueLabel,
      MultiValueRemove,
      ClearIndicator,
      DropdownIndicator,
      Option,
    }
    props.isMulti = false
    props.isClearable = false
    props.styles = singleSelectStyles(style)
  }

  const onUserChange = (user) => {
    if (multiple && user && user.length) {
      const userValue = user.map((m) => m[valueField])
      onChange(userValue)
    } else if (multiple && value) {
      onChange(null)
    } else if (!multiple) {
      onChange(user ? castArray(user && user[valueField]) : null)
    }
  }

  useEffect(() => {
    if (onFetchRemoteData) {
      const user = onFetchRemoteData('user')
      user.fetchTreeData().then((data = []) => {
        setUsers(
          data
            .filter((f) => f.active)
            .map((v) => {
              return { ...v, title: v.name }
            })
        )
      })
    }
  }, [])

  return (
    <Select
      ref={ref}
      options={users || []}
      value={(users || []).filter(
        (v) => value && value.includes(v[valueField])
      )}
      formatOptionLabel={(v) => {
        return renderOptions(v)
      }}
      isDisabled={readonly}
      hideSelectedOptions={false}
      placeholder={opts.hint || `请选择${opts.title}`}
      clearValue={() => {}}
      clearable
      noOptionsMessage={() => {
        return '暂无数据'
      }}
      filterOption={(option, inputValue) => {
        try {
          return option.data.title.indexOf(inputValue) >= 0
        } catch (error) {
          return true
        }
      }}
      onChange={onUserChange}
      {...props}
    />
  )
}

export default forwardRef(Render)
